import React, { Component } from 'react';
import classNames from 'classnames';
import styles from './style.scss';

export default class ActiveIndicator extends Component {
    
    activeMode = () => {

        return <div className={classNames(styles['item-row'], 'indicator-active')}>
                    <svg width='14px' height='14px' viewBox='0 0 14 14' version='1.1' xmlns='http://www.w3.org/2000/svg'>
                        <g id='ui-elements' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
                            <g id='UI-elements' transform='translate(-598.000000, -3242.000000)'>
                                <g id='OK' transform='translate(598.000000, 3242.000000)'>
                                    <circle id='Oval' fill='#38D87D' cx='7' cy='7' r='7'></circle>
                                    <path d='M5.30330086,6.80330086 L11.3033009,6.80330086 L11.3033009,8.80330086 L3.30330086,8.80330086 L3.30330086,6.80330086 L3.30330086,3.80330086 L5.30330086,3.80330086 L5.30330086,6.80330086 Z' id='Combined-Shape' fill='#FFFFFF' transform='translate(7.303301, 6.303301) rotate(-50.000000) translate(-7.303301, -6.303301) '></path>
                                </g>
                            </g>
                        </g>
                    </svg>
                    <span className={classNames(styles.text)} data-text>
                        {this.props.activeText}
                    </span>
               </div>;
    }

    notActiveMode = () => {

        return <div className={classNames(styles['item-row'], 'indicator-not-active')}>
                    <svg width='14px' height='14px' viewBox='0 0 14 14' version='1.1' xmlns='http://www.w3.org/2000/svg'>
                        <g id='ui-elements' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
                            <g id='UI-elements' transform='translate(-598.000000, -3267.000000)'>
                                <g id='disconected' transform='translate(598.000000, 3267.000000)'>
                                    <circle id='Oval' fill='#DA2946' cx='7' cy='7' r='7'></circle>
                                    <polygon id='Combined-Shape' fill='#FFFFFF' transform='translate(6.878680, 7.035534) rotate(-45.000000) translate(-6.878680, -7.035534) ' points='2.87867966 6.03553391 10.8786797 6.03553391 10.8786797 8.03553391 2.87867966 8.03553391'></polygon>
                                    <polygon id='Combined-Shape-Copy' fill='#FFFFFF' transform='translate(6.878680, 7.035534) scale(-1, 1) rotate(-45.000000) translate(-6.878680, -7.035534) ' points='2.87867966 6.03553391 10.8786797 6.03553391 10.8786797 8.03553391 2.87867966 8.03553391'></polygon>
                                </g>
                            </g>
                        </g>
                    </svg>
                    <span className={classNames(styles.text)} data-text>
                        {this.props.notActiveText}
                    </span>
               </div>;
    }

    render() {
        
        return (
            <div className={classNames(styles['active-indicator'])}>
                {this.props.active ? this.activeMode() : this.notActiveMode()}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/portal/controls/activeIndicator/index.jsx